module.exports = __webpack_public_path__ + "5bead4fd60263f2a0b4f4bc2e9dde7e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-10.png
// module id = 2993
// module chunks = 0